<template>
  <div class="empty-wrapper">
    <img src="../../assets/shopping-bag-big.svg" />
    <p class="inter">Your shopping bag is empty</p>
    <div class="flex justify-center">
      <router-link
        :to="{ name: 'GiftList' }"
        tag="button"
        class="button-gemnote button-gemnote--small"
      >
        <span>Send a gift</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { layouts } from '../../helpers'
export default {
  name: 'EmptyShoppingBag',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.empty-wrapper {
  padding-top: 3rem;
}

p {
  font-size: 0.938rem;
  margin: 2.5rem;
}

img {
  width: 80px;
  margin: auto;
}

.button-gemnote--small {
  height: 2.5rem;
  padding: 0 2rem;
}
</style>
